import { typedObjectKeys } from './typedObjectKeys';
/**
 * Transform key/value store into an array of the values
 * @param obj
 */
export var dictToArray = function (obj) {
    var keys = typedObjectKeys(obj);
    return keys.map(function (key) { return obj[key]; });
};
//# sourceMappingURL=dictToArray.js.map